import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Priser from "./pages/Priser";
import OmOss from "./pages/OmOss";
import Omdomen from "./pages/Omdomen";
import Kontakt from "./pages/Kontakt";
import Admin from "./pages/Admin";
import Teori from "./pages/Teori";
import Integritetspolicy from "./pages/Integritetspolicy";
import CookieConsent from "./components/CookieConsent";
import ChatWidget from "./components/ChatWidget";
import CampaignPopup from "./components/CampaignPopup";
import { campaignAnnounced } from "./lib/campaign";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Navbar />
        <div className={campaignAnnounced() ? "pt-11" : ""}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/priser" element={<Priser />} />
          <Route path="/om-oss" element={<OmOss />} />
          <Route path="/omdomen" element={<Omdomen />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/teori" element={<Teori />} />
          <Route path="/integritetspolicy" element={<Integritetspolicy />} />
        </Routes>
        </div>
        <Footer />
        <CookieConsent />
        <ChatWidget />
        <CampaignPopup />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
